import React, { Fragment, useEffect, useState, useRef } from "react";
import theme from "../../assets/theme";
import styled from "styled-components";
import CustomTable from "../common/CustomTable/MaterialCustomTable";
import labels from "../../helpers/labels.json";
import { navigate } from "@reach/router";
import COLORS from "../../assets/Colors";
import { ArrowRight } from "@material-ui/icons";
import HostService from "../../services/HostService";
import ActionBar from "../common/ActionBar";
import useUser from "../../hooks/useUser";

const ViewHostEvents = () => {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [selectedFilter, setSelectedFilter] = useState();
  const [loading, setLoading] = useState(true);
  const { userObject } = useUser();

  function formatTime(time) {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const columns = [
    {
      field: "eventName",
      title: labels.events_name,
      sorting: true,
      render: (rowData) => <Center>{rowData.eventName}</Center>,
      width: 350,
    },
    {
      field: "eventId",
      title: labels.events_id,
      render: (rowData) => (
        <HyperLink
          onClick={() => navigate(`/dashboard/host/events/${rowData?.eventId}`)}
        >
          {rowData.eventId}
        </HyperLink>
      ),
      width: 250,
    },
    {
      field: "eventDate",
      title: "Date",
      sorting: true,
      render: (rowData) => <Center>{rowData.eventDate}</Center>,
    },
    {
      field: "eventTime",
      title: "Time",
      sorting: true,
      render: (rowData) => (
        <Center>
          {rowData?.eventTime ? formatTime(rowData?.eventTime) : "-"}
        </Center>
      ),
    },
    {
      field: "",
      sorting: true,
      render: (rowData) => (
        <ButtonContainer>
          <Button
            onClick={() =>
              navigate(`/dashboard/host/events/tab`, {
                state: {
                  eventId: rowData?.eventId,
                  upcoming: true,
                  apiCall: "upcoming",
                  spotRegistration: rowData?.spotRegistration,
                },
              })
            }
          >
            View full details
          </Button>
          <ArrowRight />
        </ButtonContainer>
      ),
    },
  ];

  useEffect(() => {
    async function hostMappedEventsInfo(hostId) {
      try {
        const response = await HostService.hostMappedEventsInfo(hostId);
        setState({ data: response.mappedevents });
      } catch (error) {
        setState({ data: [] });
      } finally {
        setLoading(false);
      }
    }
    if (userObject?.hostId) {
      hostMappedEventsInfo(userObject?.hostId);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject]);

  return (
    <Fragment>
      <ActionBar breadcrumbs={["Events"]} />
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage === 1}
          pageSize={state?.length ? state?.length : 10}
          pluralTitle={"Events"}
          singularTitle={"Events"}
          placeholderText={"Search"}
          noToolbar={true}
          {...{
            columns,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          loading={loading}
          data={state?.data}
          hideFilterBar
          state={state}
        />
      </Padding>
    </Fragment>
  );
};

export default ViewHostEvents;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #454545;
`;

export const HyperLink = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const TableWrapper = styled.div``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionButton = styled.button`
  border: none;
  background: none;
  outline: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
`;

export const Button = styled.button`
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  color: #00aeef;
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontSemiBold};
`;

export const ButtonContainer = styled.div`
  display: flex;
  color: #00aeef;
`;

const Padding = styled.div`
  padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 30px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;
